var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftLeafImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 160,
    viewBox: "0 0 129 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3723 28.5282C29.0382 44.0661 41.3804 70.4868 42.4922 69.5293C75.6946 41.0026 84.3318 21.3721 84.3318 21.3721C78.6984 40.1794 50.3455 70.6066 50.3455 70.6066C109.58 66.2432 91.4268 0 91.4268 0C85.7009 14.521 63.6904 12.9948 46.3723 28.5282Z",
    fill: "#87DA59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6841 68.6097C68.7828 72.5107 60.4397 74.8487 50.7054 75.558L40.319 74.0756C39.6169 73.7699 38.9464 73.2665 38.328 72.5771C36.9792 71.0401 35.2021 67.4388 33.9148 62.7414C33.5821 61.5271 33.2957 60.2314 33.0325 58.8949C23.6138 60.9436 17.1233 64.5259 17.7097 65.2241C59.5999 113.969 88.4328 126.663 88.4328 126.663C60.8083 118.379 16.1284 76.7541 16.1284 76.7541C22.531 163.739 119.819 137.077 119.819 137.077C98.4972 128.663 100.74 96.3559 77.91 70.9027C77.1927 70.103 76.4478 69.328 75.6841 68.6097Z",
    fill: "#87DA59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLeafImg);
export default __webpack_public_path__ + "static/media/left-leaf-img.389113229c399037b0aa0fbba203d892.svg";
export { ForwardRef as ReactComponent };